/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Edit_Contract_Prepaid_FloorInputs */



/**
* | output |
* | --- |
* | "At least {amount} — that much of the budget has already been used." |
*
* @param {Partner_Edit_Contract_Prepaid_FloorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_prepaid_floor = /** @type {((inputs: Partner_Edit_Contract_Prepaid_FloorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Prepaid_FloorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mindestens ${i?.amount} — so viel des Budgets wurde bereits verbraucht.`)
	return /** @type {LocalizedString} */ (`At least ${i?.amount} — that much of the budget has already been used.`)
});